const colours = {
  blue: '#00aeef',
  orange: '#f9a13a',
  green: '#62bb46',
  grey: '#5b6063',
  red: '#ec3b3b',
  lightBlue: '#ddf6ff',
  lightOrange: '#ffe9d0',
  lightGreen: '#e4f4df',
  lightGrey: '#eef2f3',
  background: '#1b1d1e',
}

const fontSize = {
  small: '12px',
  regular: '16px',
  title: '20px',
}

/**
 * Get the applicable fonts
 *
 * @returns {any}
 *
 * ```ts
 * const fonts = font()
 * ```
 */
const font = () => {
  const fonts = {
    light: 'Roboto-Light',
    lightItalics: 'Roboto-LightItalic',
    regular: 'Roboto-Regular',
    regularItalics: 'Roboto-Italic',
    bold: 'Roboto-Bold',
    boldItalics: 'Roboto-BoldItalic',
    black: 'Roboto-Black',
    blackItalics: 'Roboto-BlackItalic',
  }

  return fonts
}

const viewportBreakpoints = {
  phone: [0, 600],
  tablet: [601, 800],
  laptop: [801, 1024],
  desktop: [1025, 1200],
  tv: [1201, 999_999],
}

export { colours, fontSize, font, viewportBreakpoints }
